$(document).ready(() => {
    jQuery.fn.bookfbq = function () {
        const action = $(this).attr('data-fpq-tag');

        switch (action) {
            case 'COLOMBIA-RETOMA':
                fbq('track', 'COLOMBIA-RETOMA');
                break;

            case 'MEJOR-SELECCION':
                fbq('track', 'MEJOR-SELECCION');
                break;
            case 'VISION-COLOMBIA':
                fbq('track', 'VISION-COLOMBIA');
                break;
            case 'INV-RESPONSABLE':
                fbq('track', 'INV-RESPONSABLE');
                break;
            default:
                return false;
        }
    }

    const to_actions = $(`[data-fpq="pixel"]`);

    jQuery.each(to_actions, function () {
        $(this).click(function () {
            $(this).bookfbq();
        });
    });
});
